import React, { Component } from 'react';
import { connect } from 'react-redux';

import i18n from 'app/common/i18n';
import StyleSheet from 'stilr';

import { statistics as getStatistics } from 'app/redux/modules/statistics';
import Loading from 'app/common/Loading';

import ListItem from './list-item';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { setTitle } from 'app/layout/redux';

function getUser(user) {
  return {
    id: user.id || user.get?.('id') || '',
    firstname: user.firstname || user.get?.('firstname') || '',
    lastname: user.lastname || user.get?.('lastname') || '',
    email: user.email || user.get?.('email') || '',
    phone: user.phone || user.get?.('phone') || '',
    uuid: user.uuid || user.get?.('uuid') || '',
    company: user.company || user.get?.('company') || '',
    companyAddress: user.companyAddress || user.get?.('companyAddress') || '',
    cvr: user.cvr || user.get?.('cvr') || '',
    type: user.type || user.get?.('type') || '',
    expireAt: user.expireAt || user.get?.('expireAt') || ''
  };
}

function isAdmin(user) {
  try {
    return (user && user.get('role') === 'admin') || false;
  } catch (e) {
    if (__DEV__) {
      console.error(e);
    }
  }
  return false;
}

const styles = StyleSheet.create({
  label: {
    display: 'inline-block',
    marginRight: '6px',
    fontSize: '10px',
    background: 'rgb(224, 224, 224)',
    borderRadius: '8px',
    padding: '0 10px',
    lineHeight: '20px',
    verticalAlign: 'top',
    textTransform: 'capitalize'
  },
  blur: {
    color: 'transparent !important',
    textShadow: '0 0 5px rgba(0,0,0,0.4)'
  }
});

function sortBy(key, asc) {
  const returnValues = asc ? [1, -1] : [-1, 1];
  let newKey = key;
  switch (key) {
    case 'bbmails':
      newKey = 'accepted';
      break;
    case 'total':
      newKey = 'totalClicks';
      break;
    case 'success':
      newKey = 'success';
      break;
    case 'forbidden':
      newKey = 'forbidden';
      break;
    case 'unqiue':
      newKey = 'uniqueClicks';
      break;
    case 'facebook':
    case 'akutbolig':
      return (a, b) =>
        a[newKey] && !b[newKey]
          ? returnValues[0]
          : !a[newKey] && b[newKey]
          ? returnValues[1]
          : a.createdAt > b.createdAt
          ? returnValues[0]
          : a.createdAt < b.createdAt
          ? returnValues[1]
          : 0;
    default:
      newKey = 'createdAt';
      break;
  }

  return (a, b) =>
    a[newKey] || 0 > b[newKey] || 0
      ? returnValues[0]
      : a[newKey] || 0 < b[newKey]
      ? returnValues[1]
      : 0;
}

@connect(
  ({ statistics, dwellings, auth: { user } }) => ({
    dwellings,
    user,
    statistics
  }),
  {
    setTitle,
    getStatistics
  }
)
@i18n
class Statistics extends Component {
  constructor(props) {
    super(props);
    this.state = null;
  }

  componentDidMount() {
    const { user: _user } = this.props;
    const user = getUser(_user);
    const landlordId = user.uuid || user.id;
    this.props.getStatistics('landlord', landlordId);
    this.props.setTitle(this.props.i18n('Statistics'));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.statistics !== nextProps.statistics) {
      this.setState({
        data: nextProps.statistics.data,
        isAsc: false
      });
    }
  }

  componentWillUnmount() {
    this.props.setTitle();
  }

  render() {
    const { disabled, style = {}, user } = this.props;
    const cellClassName = [disabled && styles.blur].filter(Boolean).join(' ');
    const admin = isAdmin(user);

    const handleSort = (value) => {
      const data = this.state?.data;
      if (!data || !value) {
        return;
      }

      const key = value;
      this.setState({
        data: data.sort(sortBy(key, this.state?.isAsc)),
        isAsc: !this.state?.isAsc
      });
    };

    const triggerLookup = (ev) => {
      ev.preventDefault();
      this.setState({ loading: true });
      const id = ev.target.id.value;
      this.props
        .getStatistics('landlord', id)
        .then(() => {
          this.setState({ loading: false });
        })
        .catch(() => {
          this.setState({ loading: false });
        });
      return false;
    };

    const makeTableCell = (value, title) => {
      return (
        <TableCell
          key={value}
          onClick={() => handleSort(value)}
          value={value}
          style={{ textAlign: 'center' }}
        >
          {this.props.i18n(title)}
        </TableCell>
      );
    };

    return (
      <div style={{ overflowX: 'auto' }}>
        {!admin ? null : (
          <form onSubmit={triggerLookup}>
            <label>{this.props.i18n('Landlord Id: ')}</label>
            <input name="id" disabled={!admin} value={this.state?.landlordId} />
          </form>
        )}
        <Table style={{ ...style, tableLayout: 'auto', minWidth: 700 }}>
          <TableHead>
            <TableRow>
              {[
                ['address', this.props.i18n('Address')],
                ['bbmails', this.props.i18n('Boligbesked-send')],
                ['unique', this.props.i18n('Boligbesked-clicks(unique)')],
                ['total', this.props.i18n('Boligbesked-clicks(total)')],
                ['success', this.props.i18n('Contact-success')],
                ['forbidden', this.props.i18n('Contact-forbidden')],
                ['facebook', this.props.i18n('Shared-on-facebook')],
                ['akutbolig', this.props.i18n('Listed-on-akutbolig')]
              ].map((header) => makeTableCell(header[0], header[1]))}
            </TableRow>
          </TableHead>
          {this.state?.data?.length ? (
            <TableBody style={{ tableLayout: 'auto' }}>
              {this.state?.data.map((item, idx) => (
                <ListItem
                  key={item._id || idx}
                  item={item}
                  cellClassName={cellClassName}
                  admin={admin}
                  user={user}
                />
              ))}
            </TableBody>
          ) : null}
        </Table>
        {this.state?.loading ? (
          <Loading />
        ) : !this.state?.data?.length ? (
          <div style={{ padding: '22px', textAlign: 'center' }}>
            <i>{this.props.i18n('No dwellings with statistics')}</i>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Statistics;